import Header from "./Header";
import Footer from "./Footer";
import Navigation from "./Navigation";

export default function Ci() {
  return (
    <div>
      <div className="sticky-wrap" style={{ minHeight: "71.1875px" }}>
        <Header />
      </div>
      <div
        className="title"
        style={{ textAlign: "center", fontSize: 30, marginBottom: "20px" }}
      >
        연계정보 처리방침
      </div>
      <Navigation />
      <div style={{ width: "100%" }}>
        <div>
          <div id="privacy-section-1">
            <div className="privacy-section-in inlineon">
              <p className="mgbotm40">
                주식회사 불타는고구마(이하 “회사”)는 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 제23조의6에 따라 이용자의 연계정보(CI) 처리에 관한 사항을 다음과 같이 공개합니다.
              </p>
              <h2>제1조 (수집 출처·항목·목적)</h2>
              <p className="mgbotm40">
                회사는 회원 재인증을 위해 본인확인기관(NICE평가정보)으로부터 본인확인 정보(연계정보(CI), 중복가입확인정보(DI), 인증수단, 통신사, 내외국인 여부, 생년월일, 성별)를 제공받으며, 이 중 연계정보(CI)는 기존회원 CI 보유 여부 확인하여 미보유 시 재인증 안내 목적으로 처리합니다.
              </p>
              <h2>제2조 (처리 방법·안전조치)</h2>
              <p className="mgbotm40">
                제공받은 연계정보(CI)는 회원 식별·재인증 목적으로 이용·대조하며, 인터넷망 전송 시 암호화(TLS)·접근권한 최소화 등 안전조치를 적용합니다. 연계정보 처리를 외부에 위탁하지 않습니다.
              </p>
              <h2>제3조 (보유·이용 기간 및 파기)</h2>
              <ol className="list-indent">
                <li>연계정보(CI)는 회원 탈퇴 시까지 보유하며, 회원 탈퇴 시 즉시 파기합니다.</li>
                <li>회사는 2026년 8월 14일까지 저장된 연계정보(CI)를 전부 파기합니다.</li>
              </ol>
              <p className="mgbotm40"></p>
              <h2>제4조 (이용자의 권리 및 행사 방법)</h2>
              <p className="mgbotm40">
                이용자는 자신의 연계정보 처리에 관하여 열람, 정정·삭제, 처리정지, 동의 철회 등을 요구할 수 있습니다. 개발팀(이메일 backend2374@bgogooma.com)으로 요청하시면, 정당한 사유가 없는 한 접수일부터 10일 이내에 조치하고 결과를 통지합니다.
              </p>
              <h2>제5조 (연계정보 보호책임자)</h2>
              <ol className="list-indent">
                <li>보호책임자 : 대표이사 최석현 (csh@bgogooma.com)</li>
                <li>보호담당자 : 개발팀장 박창현 (backend2374@bgogooma.com)</li>
                <li>침해사고 발생 시 위 창구로 접수·대응하며 관계 법령에 따라 통지·신고합니다.</li>
              </ol>
              <p className="mgbotm40"></p>
              <ul className="agree_ul mgbotm40">
                <li className="pd0">시행일자: 2026년 08월 10일</li>
              </ul>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}
